'use client';

import React from 'react';
import { BlogDocument } from '@/models/blog';
import { safeJsonLdStringify } from '@/lib/json-ld';

interface Props {
  data: BlogDocument;
  siteUrl?: string;
}

const BlogJsonLd = ({ data, siteUrl = 'https://tytum.com' }: Props) => {
  const {
    slug,
    title,
    description,
    author,
    created_at,
    updated_at,
    mainImage,
  } = data;

  const postUrl = `${siteUrl}/blog/${slug}`;

  // Get image URL - handle both string and object formats
  let imageUrl = `${siteUrl}/og/og-blog.jpg`;
  if (mainImage) {
    if (typeof mainImage === 'string') {
      imageUrl = mainImage;
    } else if (typeof mainImage === 'object' && 'url' in mainImage) {
      imageUrl = (mainImage as { url: string }).url;
    }
  }

  // Ensure image URL is absolute (prepend siteUrl if relative)
  if (imageUrl && imageUrl.startsWith('/')) {
    imageUrl = `${siteUrl}${imageUrl}`;
  }

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description: description || '',
    image: imageUrl,
    author: {
      '@type': 'Person',
      name: author || 'Tytum Team',
    },
    datePublished: created_at,
    dateModified: updated_at,
    mainEntityOfPage: postUrl,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: safeJsonLdStringify(jsonLd) }}
    />
  );
};

export default BlogJsonLd;
